module.exports = __webpack_public_path__ + "img/analysisIcon2.3bb08921.png";